export const createSearchCriterion = (searchTerm: string) => (site: any) => {
    if (!searchTerm.length) {
        return true;
    }

    return site.siteName.toLowerCase().includes(searchTerm.toLowerCase());
};
